/*
 * Copyright (c) 2025 AirAsia Berhad (Malaysia). All rights reserved.
 *
 * This software is proprietary and confidential. Unauthorized copying of this file,
 * via any medium, is strictly prohibited. Do not distribute, copy, modify, or reuse
 * any part of this code without explicit written permission from AirAsia Move.
 *
 * For internal use only.
 */

import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { View } from 'react-native';
import { StyleSheet } from 'react-native-unistyles';
import TextFieldView from '@airasia-phoenix/react-native/components/TextFieldView';
import { pd } from '@airasia-phoenix/react-native/utils/utils';
import { CheckboxView } from '../CheckboxView';
import { PromoCodeProps } from './types';

const PromoCodeView = (props: PromoCodeProps) => {
  const { promoCode, onChangeText } = props;
  const { t } = useTranslation('flights');
  const [showPromoCodeTextField, setShowPromoCodeTextField] = useState(
    Boolean(promoCode?.trim()),
  );

  useEffect(() => {
    if (promoCode && !showPromoCodeTextField) {
      setShowPromoCodeTextField(true);
    }
  }, [promoCode, showPromoCodeTextField]);

  const isPromoCodeEnabled =
    showPromoCodeTextField || Boolean(promoCode?.trim());

  return (
    <View>
      <CheckboxView
        isChecked={isPromoCodeEnabled}
        label={t('flightsSearchPage.main.promoCodeLabel')}
        onPress={(state) => {
          setShowPromoCodeTextField(state);
          if (!state) {
            onChangeText('');
          }
        }}
      />

      {isPromoCodeEnabled && (
        <View style={styles.textFieldContainer}>
          <TextFieldView
            value={promoCode}
            label={t('flightsSearchPage.main.promoCode')}
            disabled={false}
            onChangeText={(text) => {
              onChangeText(text);
            }}
          />
        </View>
      )}
    </View>
  );
};

const styles = StyleSheet.create((pd) => ({
  textFieldContainer: {
    marginTop: pd.ref.space.spacing30.px,
  },
}));

export default PromoCodeView;
